export enum Permission {
  SeoView = 'seo.view',
  SeoModify = 'seo.modify',
  SeoAdminView = 'seo_admin.view',
  SeoAdminModify = 'seo_admin.modify',
}
